module.exports = __webpack_public_path__ + "static/img/bg-goal.d54cb766.jpg";